import s from "classnames";
import e, { forwardRef as d, useMemo as E } from "react";
import { useSizeAttrs as v } from "../utils/hooks/useSizeAttrs.esm.js";
import { ScreenReaderOnly as x } from "../utils/sr-only.esm.js";
import { configIcon as h } from "./configIcon.esm.js";
const N = "_icon_1xp6f_2", y = "_icon__svg_1xp6f_14", r = {
  icon: N,
  icon__svg: y
}, I = d(
  ({
    children: l,
    icon: o,
    color: a = "var(--color-global-black)",
    dataTestId: i,
    height: n,
    srLabel: t,
    width: c,
    responsiveSize: m = "xsmall",
    className: _,
    ...f
  }, p) => {
    const u = E(() => o ? e.cloneElement(o, {
      className: s(r.icon__svg, o.props.className)
    }) : null, [o]), g = v(m, {});
    return /* @__PURE__ */ e.createElement(
      "span",
      {
        ref: p,
        "data-testid": i,
        ...f,
        className: s(r.icon, "fuse-icon", _),
        style: {
          "--icon-width": c || n,
          "--icon-height": n || c,
          "--icon-color": a
        },
        ...g
      },
      u,
      l,
      t && /* @__PURE__ */ e.createElement(x, null, t)
    );
  }
);
I.displayName = "IconElement";
export {
  I as IconElement,
  h as iconElementConfig
};
